import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.4211 3.99379C13.1596 3.73242 12.7356 3.7326 12.4743 3.9942L5.88152 10.5938L3.52656 8.23277C3.26671 7.97225 2.84524 7.97049 2.58323 8.22884C2.31884 8.48953 2.31734 8.91566 2.57989 9.17821L5.39176 11.9901C5.66225 12.2606 6.10079 12.2606 6.37129 11.9901L13.4213 4.94071C13.6828 4.67921 13.6827 4.2552 13.4211 3.99379Z", fill: "#DAE7F2" }));
const ForwardRef = forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
